import * as React from "react";
import { useIntl } from "@grandvisionhq/state";
import { ProductDetailOpticsFeatures } from "./ProductDetailOpticsFeatures.js";
/* empty css                                 */
const ProductDetailOpticsFeaturesContainer = (props) => {
  const { getLabel } = useIntl();
  const labels = {
    frame: getLabel("products.frame", { hideLabelKey: true }),
    antiReflex: getLabel("products.lens.features.antiReflex", { hideLabelKey: true }),
    antiScratch: getLabel("products.lens.features.antiScratch", { hideLabelKey: true })
  };
  return /* @__PURE__ */ React.createElement(ProductDetailOpticsFeatures, { className: props.className, labels });
};
export {
  ProductDetailOpticsFeaturesContainer
};
//# sourceMappingURL=ProductDetailOpticsFeaturesContainer.js.map
